<template>
  <v-row justify="center" dense>
    <v-col sm="6" cols="12">
      <v-select
        :error-messages="modelTransportTypeValidation"
        :items="transportTypes"
        :label="$t('delegation.form.fields.transport.transportType.name')"
        item-text="name"
        item-value="id"
        v-model="contextTransportType"
        :readonly="$store.state.Delegation.readonly === true"
        persistent-hint
        :hint="validationTransportType"
        :background-color="validationTransportType !== null ? 'blue lighten-5' : null"
      />
    </v-col>
    <v-col sm="6" v-if="modelTransportType === 1" cols="12">
      <v-autocomplete
        :error-messages="modelVehicleIdValidation"
        :items="vehicles"
        :label="$t('delegation.form.fields.transport.vehicle.name')"
        :placeholder="vehiclePlaceholder"
        item-text="fullName"
        item-value="id"
        v-model="contextVehicleId"
        :readonly="$store.state.Delegation.readonly === true"
      />
    </v-col>
    <v-col sm="6" v-if="modelTransportType !== 1" cols="12">
      <v-select
        :error-messages="modelSettlementTypeIdValidation"
        :items="settlementTypes(modelTransportType)"
        :label="$t('delegation.form.fields.transport.settlementType.name')"
        v-model="contextSettlementTypeId"
        :readonly="$store.state.Delegation.readonly === true"
      />
    </v-col>
    <v-col cols="12">
      <v-alert :value="isCompanyCarSet" color="info" icon="info" dark>
        {{ $t("delegation.form.companyVehicleAlert") }}
      </v-alert>
    </v-col>
  </v-row>
</template>

<script>
import TransportTypes from "../../../../staticData/TransportTypes";
import SettlementTypes from "../../../../staticData/TransportSettlementTypes";
import ValidationTransportType from "./validationTransportType";

export default {
  name: "FirstRowTransportSet",
  props: {
    modelTransportType: {
      required: true
    },
    modelSettlementTypeId: {
      required: true
    },
    modelVehicleId: {
      required: true
    },
    modelTransportTypeValidation: {
      required: false,
      default: function() {
        return [];
      }
    },
    modelSettlementTypeIdValidation: {
      required: false,
      default: function() {
        return [];
      }
    },
    modelVehicleIdValidation: {
      required: false,
      default: function() {
        return [];
      }
    }
  },
  data: () => ({
    vehicles: [],
    vehiclePlaceholder: null
  }),
  watch: {
    contextTransportType() {
      this.setDefaultVehicle();
    }
  },
  computed: {
    validationTransportType: function() {
      return ValidationTransportType(this);
    },
    transportTypes: TransportTypes,
    contextTransportType: {
      set: function(value) {
        this.$emit("update:modelTransportType", value);
      },
      get: function() {
        return this.modelTransportType;
      }
    },
    contextVehicleId: {
      set: function(value) {
        this.$emit("update:modelVehicleId", value);
      },
      get: function() {
        return this.modelVehicleId;
      }
    },
    contextSettlementTypeId: {
      set: function(value) {
        this.$emit("update:modelSettlementTypeId", value);
      },
      get: function() {
        return this.modelSettlementTypeId;
      }
    },
    isCompanyCarSet() {
      let contextVehicle = this.vehicles.find(v => v.id === this.contextVehicleId);
      return this.modelTransportType === 1 && this.contextVehicleId != null && contextVehicle != null && contextVehicle.is_private === false;
    }
  },
  methods: {
    settlementTypes: SettlementTypes,
    setDefaultVehicle() {
      let userId = this.$store.getters["Delegation/delegationEdited"].user_id;
      if (
        this.contextTransportType === 1 &&
        this.contextVehicleId == null &&
        this.$store.state.Delegation.delegationAvailableUsers.find(v => v.id.toString() === userId) != null
      ) {
        this.contextVehicleId = this.$store.state.Delegation.delegationAvailableUsers.find(v => v.id.toString() === userId).defaultVehicleId;
      }
    }
  },
  created() {
    this.setDefaultVehicle();
    this.axios.post("delegation/get-available-vehicles").then(resp => {
      this.vehicles = resp.data.sort((a, b) => (a.fullName > b.fullName ? 1 : -1));
      // for (let id in resp.data) {
      //     this.vehicles.push({id: id, name: resp.data[id]});
      //     if (id == this.contextVehicleId) {
      //         this.vehiclePlaceholder = resp.data[id];
      //     }
      // }
    });
    //TODO wywolywac tylko w przypadku gdy srodek transportu samochod, a pozniej przeniesc do store
  }
};
</script>

<style scoped></style>
